import { getStore } from "app/store/store"
import { ALL_CURRENCIES, CURRENCIES, ICurrency } from "currency/model"
import { state } from "currency/state"
import { getUserCurrencyId } from "user/tools/common"

export function getAvailableCurrencyIds(): string[] {
  return ALL_CURRENCIES.slice()
}

export function getCurrenciesInStore(): ICurrency[] {
  return getStore().getState().currency.currencies
}

export function convertValueIntoCurrency(fromCurrency: CURRENCIES, toCurrency: CURRENCIES, value: number): number {
  if (toCurrency === fromCurrency) {
    return value
  }
  const exchangeRates = getCadExchangeRateByCurrency()
  if (fromCurrency !== CURRENCIES.CAD) {
    value = value * exchangeRates[fromCurrency]
  }
  if (toCurrency === CURRENCIES.CAD) {
    return value
  }
  return value / exchangeRates[toCurrency]
}

export function getValueInUserCurrency(fromCurrency: CURRENCIES, value: number): number {
  return convertValueIntoCurrency(fromCurrency, getUserCurrencyId() as CURRENCIES, value)
}

export function getCadExchangeRateByCurrency(): { [key in CURRENCIES]: number } {
  if (!state.cadExchangeRateByCurrencyId) {
    const currencies = getCurrenciesInStore()
    if (currencies.length === 0) {
      // currencies not yet loaded
      return {
        [CURRENCIES.CAD]: 1,
        [CURRENCIES.EUR]: 1,
        [CURRENCIES.USD]: 1
      }
    }
    const eurCurrency = currencies.find(c => c.id === CURRENCIES.EUR)
    const usdCurrency = currencies.find(c => c.id === CURRENCIES.USD)
    if (!eurCurrency) {
      throw Error("Missing EUR currency in state")
    }
    if (!usdCurrency) {
      throw Error("Missing USD currency in state")
    }
    state.cadExchangeRateByCurrencyId = {
      [CURRENCIES.CAD]: 1,
      [CURRENCIES.EUR]: eurCurrency.exchange_rate as any,
      [CURRENCIES.USD]: usdCurrency.exchange_rate as any
    }
  }
  return state.cadExchangeRateByCurrencyId
}
